function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useMemo } from 'react';
import { useIntl } from '../../../../../theme/i18n';
import { getPartialWeeks } from '../../utilities/getPartialWeeks';
import { useDaysUtilities } from './useDaysUtilities';
export var useWeeks = _ref => {
  var {
    activeMonth,
    excludeHolidays = false,
    minDate,
    maxDate,
    weekDays,
    secondarySelectedDate,
    selectedDate,
    onSelect
  } = _ref;
  var {
    formatDate
  } = useIntl();
  var {
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  } = useDaysUtilities({
    excludeHolidays,
    minDate,
    maxDate,
    weekDays
  });
  return useMemo(() => getPartialWeeks({
    activeMonth,
    secondarySelectedDate,
    selectedDate,
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  }).map(week => week.map(day => day ? _objectSpread(_objectSpread({}, day), {}, {
    label: formatDate(day.date, {
      day: 'numeric'
    }),
    selectDay: () => onSelect(day.date)
  }) : day)), // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `formatDate` function
  [activeMonth, secondarySelectedDate, isAfterMaxDate, isBeforeMinDate, isHoliday, isInWeekDays, onSelect, selectedDate]);
};
//# sourceMappingURL=useWeeks.js.map